import script from "./EmptyMailContent.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyMailContent.vue?vue&type=script&setup=true&lang=js"

import "./EmptyMailContent.vue?vue&type=style&index=0&id=246d1830&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246d1830"]])

export default __exports__